<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="likeName"
              :placeholder="$t('common.tips.fuzzySearchForCustomEqType')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button :disabled="!$store.getters.isAdmin" no="initData" type="primary" @click="initData"> {{ $t('CargoMsg.Cargo_InitData') }} </el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }} </el-button>
        <el-button no="add" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="update" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="CustomEqType-agGrid"
        config-module="101371"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        no="CustomEqType-pagination"
        config-module="101371"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="300px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="60px" label-position="left">
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_Size') }}</span>
            <el-input-number v-model="editDialog.form.size" :disabled="editDialog.isEdit" :precision="0" :min="0" :max="999" :controls="false" no="size" />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_ContainerType') }}</span>
            <cargo-advance-select
              :disabled="editDialog.isEdit"
              no="type"
              :select-type="selectTypeNames.basic_data_EQType"
              filterable
              :default-value="editDialog.form.type"
              style="width:100%;"
              tag-name="code"
              @parentCallBack="p=>{editDialog.form.type=p.value}"
            />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ 'TEU' }}</span>
            <el-input-number v-model="editDialog.form.teu" :precision="2" :min="0" :max="99.99" :controls="false" no="teu" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  initCustomEqType,
  addCustomEqType,
  deleteCustomEqType,
  listCustomEqType,
  updateCustomEqType
} from '@/api/basicData/customEqType'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CustomEqType',
  components: { CargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 55
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Size'),
          field: 'size',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerType'),
          field: 'type',
          width: 120
        },
        {
          headerName: 'TEU',
          field: 'teu',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.UpdateTime'),
          field: 'dateModified',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: null,
      selectTypeNames: TYPE_NAMES,
      editDialog: {
        visible: false,
        title: '',
        isEdit: false,
        form: {
          uuid: '',
          size: 0,
          type: '',
          teu: 0
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (!this.rowData) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading4Cxt()
      listCustomEqType(self.filter).then(res => {
        const result = res.data.list || []
        for (let i = 0; i < result.length; i++) {
          if (!result[i]) continue
          result[i].serialNumber = (i + 1)
        }
        if (self.gridApi) {
          self.gridApi.setRowData(result)
        } else {
          self.rowData = result
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          size: undefined,
          type: '',
          teu: undefined
        }
        this.editDialog.isEdit = false
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('Information.CustomEqType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length > 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.isEdit = true
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('Information.CustomEqType')
      }
      this.editDialog.visible = true
    },
    // 保存公用-新增修改
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.size || Number(form.size) <= 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_Size') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.type) {
        self.$message.warning(self.$t('CargoMsg.Cargo_ContainerType') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!form.teu || Number(form.teu) <= 0) {
        self.$message.warning('TEU' + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const loading = getLoading4Cxt()
      if (!form.uuid) {
        self.filter.pageNum = 1
        addCustomEqType(form).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          // self.editDialog.visible = false
        }).finally(() => loading.close())
      } else {
        updateCustomEqType(form).then(res => {
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          // self.editDialog.visible = false
        }).finally(() => loading.close())
      }
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const loading = getLoading4Cxt()
      const uuids = Array.from(rows, p => p.uuid)
      deleteCustomEqType(uuids).then(res => {
        if (res.data && Number(res.data) > 0) {
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        }
        self.filter.pageNum = 1
        self.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    },
    initData() {
      if (this.total > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotInitData'))
        return
      }
      const loading = getLoading()
      initCustomEqType().then(res => {
        if (res.data && Number(res.data) > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_InitData') + this.$t('CargoMsg.Cargo_Success'))
        }
        this.filter.pageNum = 1
        this.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    }
  }
}
</script>

